import React from "react"
import { Route, Routes } from "react-router-dom"

import SearchClient from "./SearchClient/SearchClient"
import ClientInfo from "./ClientInfo/ClientInfo"

export default function Clientes() {
  return (
    <Routes>
      <Route path="/" element={<SearchClient />} />
      <Route path="/:cuit" element={<ClientInfo />}></Route>
    </Routes>
  )
}
